import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AppFilter } from "app/models/app-filter.model";
import { AbModoDebug } from "app/abstract/full-pages/integrador/modo-debug.abstract";
import { ModoDebugUsuario } from "app/models/modo-debug-usuario.model";
import { ModoDebugHistoricoItem } from "app/models/modo-debug-historico-item.model";
import { ModoDebugDadosPessoais } from "app/models/modo-debug-dados-pessoais.model";
import { Pageable } from "app/models/pageable-mode";

@Injectable({ providedIn: 'root' })
export class ModoDebugService extends AbModoDebug {

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public listar(filter: AppFilter): Observable<Pageable<ModoDebugUsuario>> {
        return this.getAll('api/v1/seguranca/modo-debug/usuarios?filter=' + filter.encode());
    }

    public listarComLiberacaoAtiva(filter: AppFilter): Observable<Pageable<ModoDebugUsuario>> {
        return this.getAll('api/v1/seguranca/modo-debug/usuarios/liberacao-ativa?filter=' + filter.encode());
    }

    public buscarPorId(usuarioId: number): Observable<ModoDebugUsuario> {
        return this.get('api/v1/seguranca/modo-debug/', usuarioId);
    }

    public historico(usuarioId: number, filter: AppFilter): Observable<Pageable<ModoDebugHistoricoItem>> {
        return this.getAll('api/v1/seguranca/modo-debug/' + usuarioId + '/historico?filter=' + filter.encode());
    }

    public dadosPessoais(usuarioId: number): Observable<ModoDebugDadosPessoais> {
        return this.get('api/v1/seguranca/modo-debug/' + usuarioId + '/dados-pessoais');
    }

    public ativar(usuarioId: number): Observable<any> {
        return this.post('api/v1/seguranca/modo-debug/' + usuarioId, {});
    }

    public renovar(usuarioId: number): Observable<any> {
        return this.patch('api/v1/seguranca/modo-debug/' + usuarioId, {});
    }

    public revogar(usuarioId: number): Observable<any> {
        return this.delete('api/v1/seguranca/modo-debug/', usuarioId);
    }
}
